var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZap(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 24,
    viewBox: "0 0 16 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 8.99999H9.062L9.996 1.11799C9.999 1.09899 10 1.01999 10 0.99999C10.0013 0.868296 9.97638 0.73766 9.9266 0.61573C9.87682 0.493801 9.80321 0.383029 9.71009 0.289903C9.61696 0.196777 9.50619 0.123168 9.38426 0.0733868C9.26233 0.0236056 9.13169 -0.0013471 9 -1.00078e-05C8.687 -1.00078e-05 8.387 0.14899 8.184 0.42299L0.2 12.4C0.0709998 12.572 0 12.785 0 13C0 13.561 0.439 14 1 14H5.944L5.003 22.897C5.001 22.9313 5 22.9656 5 23C5 23.561 5.439 24 6 24C6.313 24 6.613 23.851 6.811 23.584L15.8 10.6C15.929 10.428 16 10.215 16 9.99999C16.0013 9.8683 15.9764 9.73766 15.9266 9.61573C15.8768 9.4938 15.8032 9.38303 15.7101 9.2899C15.617 9.19678 15.5062 9.12317 15.3843 9.07339C15.2623 9.02361 15.1317 8.99865 15 8.99999Z",
    fill: "#FACF06"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZap);
export default __webpack_public_path__ + "static/media/zap.6f9dcffc6b6644ad3c3cdda867aacb15.svg";
export { ForwardRef as ReactComponent };